import { useGetFeatureEnabledForCountry } from './useGetFeatureEnabledForCountry';

function useIsTierVerificationEnabled() {
  const { isTierVerificationEnabled: isTierVerificationEnabledForCountry } =
    useGetFeatureEnabledForCountry();

  return isTierVerificationEnabledForCountry;
}

export default useIsTierVerificationEnabled;
